module.exports = __webpack_public_path__ + "b3ec4bfa7ee88a67a1346fe991ccf2a8.jpg";